import { render } from "./ArrowTopRightIcon.vue?vue&type=template&id=79864170"
import script from "./ArrowTopRightIcon.vue?vue&type=script&lang=js"
export * from "./ArrowTopRightIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__